(() => {
  const roots = new WeakSet();
  function publish(name, details) {
    const privacy = window.Shopify?.customerPrivacy;
    if (!privacy?.analyticsProcessingAllowed?.()) return;
    if (typeof window.Shopify.analytics?.publish === 'function') {
      try { window.Shopify.analytics.publish(name, details)?.catch?.(() => {}); } catch {}
    }
  }
  function init(root) {
    if (!root || roots.has(root)) return;
    roots.add(root);
    if (!window.Shopify?.customerPrivacy && typeof window.Shopify?.loadFeatures === 'function') window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], () => {});
    const players = Array.from(root.querySelectorAll('[data-home-player]'));
    const labels = { play: root.dataset.playLabel, pause: root.dataset.pauseLabel, loading: root.dataset.loadingLabel };
    for (const player of players) {
      const audio = player.querySelector('audio');
      const controls = player.querySelector('.hc-player__custom');
      const button = player.querySelector('button');
      const seek = player.querySelector('input[type="range"]');
      const time = player.querySelector('.hc-player__time');
      const status = player.querySelector('.hc-player__status');
      const error = player.querySelector('.hc-player__error');
      let pending = false;
      let counted = false;
      const name = player.dataset.previewName;
      const clock = value => Number.isFinite(value) ? `${Math.floor(value / 60)}:${String(Math.floor(value % 60)).padStart(2, '0')}` : '0:00';
      const state = playing => {
        player.classList.toggle('is-playing', playing);
        button.setAttribute('aria-pressed', String(playing));
        button.setAttribute('aria-label', `${playing ? labels.pause : labels.play} ${name}`);
      };
      const update = () => {
        const duration = audio.duration;
        const usable = Number.isFinite(duration) && duration > 0;
        seek.disabled = !usable;
        const progress = usable ? Math.min(1000, Math.round(audio.currentTime / duration * 1000)) : 0;
        seek.value = String(progress);
        seek.style.setProperty('--progress', `${progress / 10}%`);
        seek.setAttribute('aria-valuetext', `${clock(audio.currentTime)} / ${usable ? clock(duration) : '0:00'}`);
        time.textContent = clock(audio.currentTime);
      };
      button.addEventListener('click', () => {
        if (pending || !audio.paused) {
          pending = false;
          audio.pause();
          state(false);
          status.textContent = '';
          return;
        }
        pending = true;
        error.hidden = true;
        status.textContent = labels.loading;
        if (audio.error) audio.load();
        audio.play().catch(reason => {
          pending = false;
          state(false);
          status.textContent = '';
          if (reason.name !== 'AbortError') error.hidden = false;
        });
      });
      audio.addEventListener('play', () => {
        for (const other of document.querySelectorAll('audio')) if (other !== audio) other.pause();
        state(true);
      });
      audio.addEventListener('playing', () => {
        pending = false;
        status.textContent = '';
        if (!counted) {
          counted = true;
          publish('flowstate:preview_played', { product_handle: player.dataset.productHandle, preview_type: 'homepage', preview_index: players.indexOf(player) + 1 });
        }
      });
      audio.addEventListener('waiting', () => { if (!audio.paused) status.textContent = labels.loading; });
      for (const event of ['pause', 'ended']) audio.addEventListener(event, () => {
        pending = false;
        counted = false;
        status.textContent = '';
        state(false);
        update();
      });
      audio.addEventListener('error', () => {
        pending = false;
        status.textContent = '';
        state(false);
        error.hidden = false;
      });
      for (const event of ['loadedmetadata', 'durationchange', 'timeupdate', 'seeked']) audio.addEventListener(event, update);
      seek.addEventListener('input', () => {
        if (Number.isFinite(audio.duration) && audio.duration > 0) audio.currentTime = audio.duration * Number(seek.value) / 1000;
        update();
      });
      audio.controls = false;
      controls.hidden = false;
    }
    root.addEventListener('click', event => {
      const link = event.target.closest('a[data-hc-link]');
      if (link?.dataset.hcLink === 'free_signup' && document.querySelector('script[src*="klaviyo"]')) {
        event.preventDefault();
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', 'WaVGtK']);
      }
      if (link) publish('flowstate:home_clicked', { placement: link.dataset.hcLink, product_handle: link.dataset.hcProduct || '', destination: new URL(link.href, location.href).pathname + new URL(link.href, location.href).hash });
    });
    window.addEventListener('pagehide', () => players.forEach(player => player.querySelector('audio').pause()));
  }
  document.querySelectorAll('[data-home-conversion]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-home-conversion]').forEach(init));
})();
